export default __webpack_public_path__ + "static/media/logo_tartu_est.8e87f91c.png";